import { css } from '@emotion/css'

const styles = {
  card: css({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  }),
  listItem: css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  }),
  listName: css({
    width: 145,
  }),
  listActions: css({
    width: 54,
  }),
  listMeta: css({
    width: 200,
  }),
}

export default styles
